import React from 'react';
import './terms.of.service.css';
import { useNavigate } from "react-router-dom";
import GetLangConfig from '../../util/LangUtil';

export default function TermsOfService() {

    const history = useNavigate();
    const langConfig = GetLangConfig('tos');

    return (
            <div className="terms-of-service-container">
                <h1 dangerouslySetInnerHTML={{ __html: langConfig.tos.header }}></h1>
                <p>{langConfig.tos.p1}</p>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: langConfig.tos.p2 }}></span>
                    <br />
                    <ol>
                        <li dangerouslySetInnerHTML={{ __html: langConfig.tos.li1 }}></li>
                        <li dangerouslySetInnerHTML={{ __html: langConfig.tos.li2 }}></li>
                        <li>{langConfig.tos.li3}</li>
                    </ol>
                </p>
                <p dangerouslySetInnerHTML={{ __html: langConfig.tos.p3 }}></p>
                <p>{langConfig.tos.p4}</p>
                <p>{langConfig.tos.p5}</p>
                <p dangerouslySetInnerHTML={{ __html: langConfig.tos.p6 }}></p>
                <p>{langConfig.tos.p7}</p>

                <ul>
                    <li>
                        <div><b>{langConfig.tos.p8}</b></div>
                        <p>
                            <span dangerouslySetInnerHTML={{ __html: langConfig.tos.p9 }}></span>
                            <br/>
                            <ol>
                                <li>{langConfig.tos.li4}</li>
                                <li>{langConfig.tos.li5}</li>
                                <li>{langConfig.tos.li6}</li>
                                <li>{langConfig.tos.li7}</li>
                            </ol>
                            <br/>
                            <span dangerouslySetInnerHTML={{ __html: langConfig.tos.p10 }}></span>
                        </p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p11}</b></div>
                        <p>
                            {langConfig.tos.p12}
                            <br/>
                            <br/>
                            <ul style={{ listStyle : 'none', listStyleType: 'circle' }}>
                                <li>
                                    <div><span dangerouslySetInnerHTML={{ __html: langConfig.tos.p13 }}></span></div>
                                    <p>{langConfig.tos.p14}</p>
                                    <p>{langConfig.tos.p15}</p>
                                    <p>{langConfig.tos.p16}</p>
                                </li>
                                <li>
                                    <div><span dangerouslySetInnerHTML={{ __html: langConfig.tos.p17 }}></span></div>
                                    <p>{langConfig.tos.p18}</p>
                                </li>

                            </ul>
                            <br/>
                        </p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p19}</b></div>
                        <p dangerouslySetInnerHTML={{ __html: langConfig.tos.p20 }}></p>
                        <p dangerouslySetInnerHTML={{ __html:langConfig.tos.p21 }}></p>
                        <ul>
                            <li>{langConfig.tos.p22}</li>
                            <li>{langConfig.tos.p23}</li>
                            
                        </ul>
                    <br/>    
                    </li>
                    <li>
                    
                        <div><b>{langConfig.tos.p24}</b></div>

                        <p dangerouslySetInnerHTML={{ __html: langConfig.tos.p25 }}></p>
                        <p>{langConfig.tos.p26}</p>
                        <p>{langConfig.tos.p27}</p>
                        <p>{langConfig.tos.p28}</p>
                        <p>{langConfig.tos.p29}</p>
                        <p>{langConfig.tos.p30}</p>
                        <p>{langConfig.tos.p31}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p32}</b></div>
                        <p>{langConfig.tos.p33}</p>
                        <p>{langConfig.tos.p34}</p>
                        <p>{langConfig.tos.p35}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p36}</b></div>
                        <p>
                            {langConfig.tos.p37}
                            <br/>
                            <br/>
                            <ol>
                                <li>{langConfig.tos.li8}</li>
                                <li>{langConfig.tos.li9}</li>
                                <li>{langConfig.tos.li10}</li>
                                <li>{langConfig.tos.li11}</li>
                                <li>{langConfig.tos.li12}</li>
                                <li>{langConfig.tos.li13}</li>
                                <li>{langConfig.tos.li14}</li>
                                <li>{langConfig.tos.li15}</li>
                                <li>{langConfig.tos.li16}</li>

                            </ol>
                        </p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p38}</b></div>
                        <p><span dangerouslySetInnerHTML={{ __html: langConfig.tos.p39 }}></span> <span className="privacy-policy" onClick={(e) => history('/privacypolicy')}>{langConfig.tos.p40}</span>. {langConfig.tos.p41}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p42}</b></div>
                        <p>{langConfig.tos.p43}</p>
                        <p>{langConfig.tos.p44}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p45}</b></div>
                        <p>{langConfig.tos.p46}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p47}</b></div>
                        <p>{langConfig.tos.p48}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p49}</b></div>
                        <p>{langConfig.tos.p50}</p>
                        <p>{langConfig.tos.p51}</p>
                        <p>{langConfig.tos.p52}</p>
                        <p>{langConfig.tos.p53}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p54}</b></div>
                        <p dangerouslySetInnerHTML={{ __html: langConfig.tos.p55 }}></p>
                        <p>{langConfig.tos.p56}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p57}</b></div>
                        <p>
                            <span dangerouslySetInnerHTML={{ __html: langConfig.tos.p58 }}></span>
                            <br/>
                            <br/>
                            <ol>
                                <li>{langConfig.tos.li17}</li>
                                <li>{langConfig.tos.li18}</li>
                                <li>{langConfig.tos.li19}</li>
                                <li>{langConfig.tos.li20}</li>
                            </ol>
                            <br/>
                            {langConfig.tos.p59}
                        </p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p60}</b></div>
                        <p>{langConfig.tos.p61}</p>
                        <ul>
                            <li>{langConfig.tos.li21}</li>
                            <li>{langConfig.tos.li22}</li>
                            <li>{langConfig.tos.li23}</li>
                            <li>{langConfig.tos.li24}</li>
                        </ul>
                        <p>{langConfig.tos.p62}</p>
                        <ul>
                            <li>{langConfig.tos.li25}</li>
                            <li>{langConfig.tos.li26}</li>
                        </ul>
                        <p>{langConfig.tos.p63}</p>
                    </li>
                    <br/>
                    <li>
                        <div><b>{langConfig.tos.p64}</b></div>
                        <p>{langConfig.tos.p65}</p>
                        <p>{langConfig.tos.p66}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p67}</b></div>
                        <p>{langConfig.tos.p68}</p>
                        <p>{langConfig.tos.p69}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p70}</b></div>
                        <p>{langConfig.tos.p71}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p72}</b> </div>
                        <p>{langConfig.tos.p73}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p74}</b></div>
                        <p>{langConfig.tos.p75}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p76}</b></div>
                        <p>{langConfig.tos.p77}</p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p78}</b></div>
                        <p>
                            {langConfig.tos.p79}
                            <br/>
                            <br/>
                            <ol>
                                <li>{langConfig.tos.li27}</li>
                                <li>{langConfig.tos.li28}</li>
                                <li>{langConfig.tos.li29}</li>
                                <li>{langConfig.tos.li30}</li>
                                <li>{langConfig.tos.li31}</li>
                            </ol>
                        </p>
                    </li>
                    <li>
                        <div><b>{langConfig.tos.p80}</b></div>
                        <p>{langConfig.tos.p81}</p>
                    </li>
                </ul>
            </div>
        );

}